export const CAMERA_DENIED_SNACK_MESSAGE = 'Enable camera permission in phone settings'
